import { PageType } from "@/types";
import { Environment } from "@react-three/drei";
import { useFrame, useThree } from "@react-three/fiber";
import { useEffect, useMemo, useRef, useState } from "react";
import { BackSide, VideoTexture, TextureLoader, PointLight, Vector3 } from "three";

export default function EnvironmentBackground({ image, video, page }: { image: string | null; video: VideoTexture | null; page: PageType }) {
	const [isHDR, setIsHDR] = useState(image?.endsWith(".hdr"));
	const texture = useMemo(() => (image && !isHDR ? new TextureLoader().load(image) : null), []);

	const { camera } = useThree();
	const lightRef = useRef<PointLight>(null);
	const tempVec = useMemo(() => new Vector3(), []);

	// Aktualisiert die Lichtposition bei aktivem Video
	useFrame(() => {
		if (video && lightRef.current) {
			camera.getWorldPosition(tempVec);
			lightRef.current.position.copy(tempVec);
		}
	});

	useEffect(() => {
		return () => {
			if (texture) {
				texture.dispose(); // Freigeben der Textur
				console.log("Disposing texture...");
			}
		};
	}, [texture]);

	return (
		<>
			{!video && image && (
				<>
					{isHDR && <Environment background files={[image]}></Environment>}

					{!isHDR && (
						<Environment background>
							<mesh scale={100}>
								<sphereGeometry args={[1, 64, 64]} />
								<meshBasicMaterial map={texture} side={BackSide} />
							</mesh>
						</Environment>
					)}
				</>
			)}
			{video && (
				<>
					<Environment background frames={Infinity} resolution={256}>
						<mesh scale={100}>
							<sphereGeometry args={[1, 64, 64]} />
							<meshBasicMaterial map={video} side={BackSide} />
						</mesh>
					</Environment>

					<ambientLight intensity={1} />
					<pointLight ref={lightRef} intensity={1} distance={0} decay={0} />
				</>
			)}
		</>
	);
}
